module.exports = __webpack_public_path__ + "static/media/GT-America-Extended-Medium.78b3d2f6.otf";